import { render, staticRenderFns } from "./ChatProspectsCard.vue?vue&type=template&id=557db1db"
import script from "./ChatProspectsCard.vue?vue&type=script&lang=js"
export * from "./ChatProspectsCard.vue?vue&type=script&lang=js"
import style0 from "./ChatProspectsCard.vue?vue&type=style&index=0&id=557db1db&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports